import { render, staticRenderFns } from "./quotationTabsDetails.vue?vue&type=template&id=b3a92c76&"
import script from "./quotationTabsDetails.vue?vue&type=script&lang=js&"
export * from "./quotationTabsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports